import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { encryptStorage } from 'src/app/auth/utils/storage';
import { showDefaultError } from 'src/app/shared/utils/functions/notification.function';
import { SolicitarGarantiaService } from '../../services/solicitar-garantia.service';

@Component({
  selector: 'app-modal-detalhes-ativos',
  templateUrl: './modal-detalhes-ativos.component.html',
  styleUrls: ['./modal-detalhes-ativos.component.scss']
})
export class ModalDetalhesAtivosComponent implements OnInit {

  model: any
  data: any
  tipoUsuario: string = ''


  constructor(private modalRef: MDBModalRef, private solicitarService: SolicitarGarantiaService) { }

  ngOnInit(): void {
    this.tipoUsuario = encryptStorage.getItem('@tipoUsuario', false)
    this.listarDetalhes()
  }

  listarDetalhes(){
    this.solicitarService.listarDetalheSolicitacao(this.model.idInvestidor).subscribe(
      res => this.data = res['data'],
      e => showDefaultError(e),
      // () => console.log(this.data)
    )
  }

  closeModal(){return this.modalRef.hide()}
}
